function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.76.26a5 5 0 00-5.1 4.92v2.05h-1.7c-.7 0-1.28.56-1.28 1.23v9.83c0 .68.57 1.23 1.27 1.23h13.62c.7 0 1.27-.55 1.27-1.23V8.46c0-.67-.57-1.23-1.27-1.23h-1.7V5.18A5 5 0 008.75.26zm0 .82a4.15 4.15 0 014.25 4.1v2.05h-8.5V5.18c0-2.28 1.88-4.1 4.25-4.1zm-6.8 6.97h13.6c.24 0 .43.18.43.41v9.83c0 .23-.19.41-.42.41H1.95a.42.42 0 01-.42-.4V8.45c0-.23.19-.41.42-.41zm6.8 3.28c-.72 0-1.28.53-1.28 1.23 0 .37.17.69.43.9v1.15c0 .45.38.82.85.82s.85-.37.85-.82v-1.16c.26-.2.43-.52.43-.9 0-.69-.56-1.22-1.28-1.22z"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none",
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.634a8601.svg";
export { ForwardRef as ReactComponent };